import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { getAuthToken } from '../../utils/utils';
import postService from './post.service';

const initialState = {
  posts: [],
  loading: false,
  error: null,
};

export const getAllPosts = createAsyncThunk(
  'posts/getAllPosts',
  async (_, thunkAPI) => {
    const {
      auth: { user },
    } = thunkAPI.getState('auth');

    try {
      const res = await postService.showAllPosts({
        userid: user._id,
      });

      return res.data.data;
    } catch (err) {
      console.log(err);
      return thunkAPI.rejectWithValue({ error: err });
    }
  }
);

export const createPost = createAsyncThunk(
  'posts/createPost',
  async (payload, thunkAPI) => {
    const {
      auth: { user },
    } = thunkAPI.getState('auth');
    payload.userid = user._id;
    // console.log('payload:', payload);
    try {
      const res = await postService.createPost({
        payload,
      });
      if (res.data?.code === 1 || res.data?.status === 1) {
        toast.success('Post created successfully!');
      }
      return res.data;
    } catch (err) {
      console.error(err);
      return thunkAPI.rejectWithValue({ error: err });
    }
  }
);

const postSlice = createSlice({
  name: 'post',
  initialState,
  reducers: {},
  extraReducers: {
    [getAllPosts.pending]: (state) => {
      state.loading = true;
    },
    [getAllPosts.fulfilled]: (state, action) => {
      state.loading = false;
      state.posts = action.payload;
    },
    [getAllPosts.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [createPost.pending]: (state) => {
      state.loading = true;
    },
    [createPost.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [createPost.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default postSlice.reducer;
